export const USER_ROLES = {
  SUPER_ADMINISTRATOR: "super_admin",
};
